export const state = {
  message: '',
  error: '',
  warning: '',
  menuCollapsed: true,
  modalTabVideosBeingShown: false,
  modalCheckPendingInvoiceBeingShown: false,
  modalAccessCollaboratorRemainingBeingShown: false,
  modalPlanTrialBeingShown: false,
  modalUpdateNewBeingShown: false,
  modalRenewBeingShown: false,
  modalBlockBeingShown: false,
}

export const mutations = {
  SET_MESSAGE(state, data) {
    state.message = data
  },
  SET_ERROR(state, data) {
    state.error = data
  },
  SET_WARNING(state, data) {
    state.warning = data
  },
  SET_MENU_COLLAPSED(state, menuCollapsed) {
    state.menuCollapsed = menuCollapsed
  },
  SET_MODAL_TAB_VIDEOS_BEING_SHOWN(state, modalTabVideosBeingShown) {
    state.modalTabVideosBeingShown = modalTabVideosBeingShown
  },
  SET_MODAL_CHECK_PENDING_INVOICE_BEING_SHOWN(state, modalCheckPendingInvoiceBeingShown) {
    state.modalCheckPendingInvoiceBeingShown = modalCheckPendingInvoiceBeingShown
  },
  SET_MODAL_ACCESS_COLLABORATOR_REMAINING_BEING_SHOWN(state, modalAccessCollaboratorRemainingBeingShown) {
    state.modalAccessCollaboratorRemainingBeingShown = modalAccessCollaboratorRemainingBeingShown
  },
  SET_MODAL_PLAN_TRIAL_BEING_SHOWN(state, modalPlanTrialBeingShown) {
    state.modalPlanTrialBeingShown = modalPlanTrialBeingShown
  },
  SET_MODAL_UPDATE_NEW_BEING_SHOWN(state, modalUpdateNewBeingShown) {
    state.modalUpdateNewBeingShown = modalUpdateNewBeingShown
  },
  SET_MODAL_RENEW_BEING_SHOWN(state, modalRenewBeingShown) {
    state.modalRenewBeingShown = modalRenewBeingShown
  },
  SET_MODAL_BLOCK_BEING_SHOWN(state, modalBlockBeingShown) {
    state.modalBlockBeingShown = modalBlockBeingShown
  },
}

export const actions = {
  async updateMessage({ commit }, message) {
    commit('SET_MESSAGE', message)
  },
  async updateError({ commit }, error) {
    commit('SET_ERROR', error)
  },
  async updateWarning({ commit }, warning) {
    commit('SET_WARNING', warning)
  },
  async updateMenuCollapsed({ commit }, menuCollapsed) {
    commit('SET_MENU_COLLAPSED', menuCollapsed)
  },
  async updateModalTabVideosBeingShown({ commit }, modalTabVideosBeingShown) {
    commit('SET_MODAL_TAB_VIDEOS_BEING_SHOWN', modalTabVideosBeingShown)
  },
  async updateModalCheckPendingInvoiceBeingShown({ commit }, modalCheckPendingInvoiceBeingShown) {
    commit('SET_MODAL_CHECK_PENDING_INVOICE_BEING_SHOWN', modalCheckPendingInvoiceBeingShown)
  },
  async updateModalAccessCollaboratorRemainingBeingShown({ commit }, modalAccessCollaboratorRemainingBeingShown) {
    commit('SET_MODAL_ACCESS_COLLABORATOR_REMAINING_BEING_SHOWN', modalAccessCollaboratorRemainingBeingShown)
  },
  async updateModalPlanTrialBeingShown({ commit }, modalPlanTrialBeingShown) {
    commit('SET_MODAL_PLAN_TRIAL_BEING_SHOWN', modalPlanTrialBeingShown)
  },
  async updateModalUpdateNewBeingShown({ commit }, modalUpdateNewBeingShown) {
    commit('SET_MODAL_UPDATE_NEW_BEING_SHOWN', modalUpdateNewBeingShown)
  },
  async updateModalRenewBeingShown({ commit }, modalRenewBeingShown) {
    commit('SET_MODAL_RENEW_BEING_SHOWN', modalRenewBeingShown)
  },
  async updateModalBlockBeingShown({ commit }, modalBlockBeingShown) {
    commit('SET_MODAL_BLOCK_BEING_SHOWN', modalBlockBeingShown)
  },
}

export const getters = {
  error: (state) => state.error,
  message: (state) => state.message,
  warning: (state) => state.warning,
  menuCollapsed: (state) => state.menuCollapsed,
  modalTabVideosBeingShown: (state) => state.modalTabVideosBeingShown,
  modalCheckPendingInvoiceBeingShown: (state) => state.modalCheckPendingInvoiceBeingShown,
  modalAccessCollaboratorRemainingBeingShown: (state) => state.modalAccessCollaboratorRemainingBeingShown,
  modalPlanTrialBeingShown: (state) => state.modalPlanTrialBeingShown,
  modalUpdateNewBeingShown: (state) => state.modalUpdateNewBeingShown,
  modalRenewBeingShown: (state) => state.modalRenewBeingShown,
  modalBlockBeingShown: (state) => state.modalBlockBeingShown,
  noModalBeingShown: (state) => {
    return ![
      state.modalTabVideosBeingShown,
      state.modalCheckPendingInvoiceBeingShown,
      state.modalAccessCollaboratorRemainingBeingShown,
      state.modalPlanTrialBeingShown,
      state.modalUpdateNewBeingShown,
      state.modalRenewBeingShown,
      state.modalBlockBeingShown,
    ].some(Boolean)
  }
}
